import { Component, OnDestroy, OnInit } from '@angular/core';
import { ImpersonationService } from '../../services/impersonation.service';

@Component({
  selector: 'app-impersonation-banner',
  templateUrl: './impersonation-banner.component.html',
  styleUrls: ['./impersonation-banner.component.scss'],
  standalone: false
})
export class ImpersonationBannerComponent implements OnInit, OnDestroy {
  isImpersonating = false;
  impersonationData: { impersonator_email: string } | null = null;
  timeRemaining = 0;
  timeRemainingFormatted = '';

  private tickInterval?: ReturnType<typeof setInterval>;

  constructor(private service: ImpersonationService) {}

  ngOnInit(): void {
    this.service.init();
    this.isImpersonating = this.service.isImpersonating;
    this.impersonationData = this.service.impersonationData;
    if (!this.isImpersonating) return;
    document.body.classList.add('impersonating');
    this.recompute();
    this.tickInterval = setInterval(() => this.recompute(), 1000);
  }

  ngOnDestroy(): void {
    if (this.tickInterval) clearInterval(this.tickInterval);
    document.body.classList.remove('impersonating');
  }

  private recompute(): void {
    const now = Math.floor(Date.now() / 1000);
    this.timeRemaining = Math.max(this.service.expiresAt - now, 0);
    const m = Math.floor(this.timeRemaining / 60);
    const s = this.timeRemaining % 60;
    this.timeRemainingFormatted = `${m}m ${s.toString().padStart(2, '0')}s`;
    if (this.timeRemaining <= 0) this.exitImpersonation();
  }

  exitImpersonation(): void {
    if (this.tickInterval) clearInterval(this.tickInterval);
    void this.service.exit();
  }
}
